import styled, {keyframes} from 'styled-components'

const radiactiveAnimation = keyframes`
  0% {
    transform: translate(0);
	}
  10% {
    transform: translate(-5%, -5%);
	}
  20% {
    transform: translate(-10%, 5%);
	}
  30% {
    transform: translate(5%, -10%);
	}
  40% {
    transform: translate(-5%, 15%);
	}
  50% {
    transform: translate(-10%, 5%);
	}
  60% {
    transform: translate(15%);
	}
  70% {
    transform: translateY(10%);
	}
  80% {
    transform: translate(-15%);
	}
  90% {
    transform: translate(10%, 5%);
	}
  to {
    transform: translate(5%);
	}
`;

const StLayout = styled.div`
	.radioactivity{
		position:fixed;
    top:0px;
    left:0px;
    width:100%;
    height:100%;
    pointer-events: none;
		z-index: 1;

	}
`

export { StLayout }